var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrophyIcon = function SvgTrophyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentcolor",
    strokeWidth: 2,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 5c0 4 1.4 7.8 3.5 8.5v2c-1.2.7-1.2 1-1.6 4h8c-.4-3-.4-3.3-1.6-4v-2c2.1-.7 3.5-4.5 3.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 8.3c-2.5-1.6-3.5 1-3 2.5 1 1.7 2.6 2.5 4.5 1.8M17.6 8.3c2.5-1.6 3.5 1 3 2.5-1 1.7-2.6 2.5-4.5 1.8"
  }))));
};
export default SvgTrophyIcon;